<input #inputFile style="display: none" type="file" [disabled]="disabled" [multiple]="multiple" [accept]="accept" (change)="onChangeFile($event)">

<button type="button" (click)="inputFile.click()" [disabled]="disabled" class="btn btn-success" [ngClass]="classes">
    <ng-container *ngIf="content; else noContent"><ng-content></ng-content></ng-container>
    <ng-template #noContent>
        <em class="fa fa-upload mr-2"></em>
        {{ 'Upload' | localize }}
    </ng-template>
</button>
